const ALL_PERMISSIONS = '*',
  ALL_TYPES = '*',
  GLOBAL_CONTEXT = '__global__';

const checkPermissionWithAll = (permissions, permission) => {
  return (permissions.includes(ALL_PERMISSIONS) || permissions.includes(permission));
};

export default class {
  /**
   * Creates a wrapper around a response from the ace security permission endpoint
   * @param {object} authorizationInfo An object like the response data from the PermissionService.getAuthorizationInfo
   * @param {object} authorizationInfo.roles A map of role:types where each role contains a map of type:permissionsList
   * @param {object} authorizationInfo.contexts A map of contexts to an array of role names
   */
  constructor ({ roles, contexts } = { roles: {}, contexts: {} }) {
    this.roles = JSON.parse (JSON.stringify (roles));
    this.contexts = JSON.parse (JSON.stringify (contexts));
  }

  /**
   * Check the provided permission for the current user for a specific type in a set of security contexts
   * @param {string} permission The name of the permission to check for
   * @param {string} forType The name of the content type the permission should be checked for
   * @param {string[]} [userContexts] A list of contexts to do the permission check in. If omitted the
   *   function will determine if the logged in user has the certain permission for the type in ANY context the
   *   user has permissions in.
   */
  hasPermission (permission, forType, userContexts) {
    if (!userContexts) {
      userContexts = Object.keys (this.contexts);
    }
    userContexts = new Set (userContexts);
    userContexts.add (GLOBAL_CONTEXT);

    for (let context of userContexts) {
      if (this.contexts[context] && Symbol.iterator in Object (this.contexts[context])) {
        for (let roleName of this.contexts[context]) {
          if (this.roles[roleName]) {

            if (this.roles[roleName][ALL_TYPES]) {
              if (checkPermissionWithAll (this.roles[roleName][ALL_TYPES], permission)) {
                return true;
              }
            }

            if (this.roles[roleName][forType]) {
              if (checkPermissionWithAll (this.roles[roleName][forType], permission)) {
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
}
